




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'badge-logopfsc-component',
})
export default class LogoPfscComponent extends Vue {
}
